import restService from './restService'

export default {
  getActive () {
    return restService.execute('get', '/v1/organisations/all/web')
  },
  get (id) {
    return restService.execute('get', `/v1/organisations/${id}`)
  },
  create (data) {
    return restService.execute('post', '/v1/organisations', data)
  },
  update (id, data) {
    return restService.execute('put', `/v1/organisations/${id}`, data)
  },
  delete (id) {
    return restService.execute('delete', `/v1/organisations/${id}`)
  },
}
